import { graphql } from '@teachino/shared-infrastructure';

export const syncNewItemsFromTopicTemplateMutation = graphql(`
  mutation SyncNewItemsFromTopicTemplate($topicId: String!) {
    syncTopicWithTemplate(
      topicTemplateSyncInput: { id: $topicId, syncMode: NEW }
    ) {
      done
    }
  }
`);
